import React from 'react';
import { cn } from '@/lib/utils';

const Brand = ({ size = 'md', showText = true, text = 'Tag' }) => {
	const sizes = {
		sm: { iconBox: 'h-8 w-8 p-1.5', icon: 'h-5 w-5', text: 'text-lg' },
		md: { iconBox: 'h-10 w-10 p-2', icon: 'h-6 w-6', text: 'text-xl' },
		lg: { iconBox: 'h-12 w-12 p-2.5', icon: 'h-7 w-7', text: 'text-2xl' }
	};
	const s = sizes[size] || sizes.md;

	return (
		<div className="flex items-center gap-3">
			<div className={cn('flex items-center justify-center rounded-lg bg-black', s.iconBox)}>
				<img src="/logo.svg" alt="Tag logo" className={s.icon} />
			</div>

			{showText ? (
				<div className={cn('font-bold text-foreground', s.text)}>
					{text}
				</div>
			) : null}
		</div>
	);
};

export default Brand;
